'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimPadEnd() {
	var polyfill = getPolyfill();
	define(String.prototype, { padEnd: polyfill }, { padEnd: function () { return String.prototype.padEnd !== polyfill; } });
	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/string.prototype.padend/shim.js
// module id = 811
// module chunks = 0